<template>
  <!-- 待我审批的、我已审批的、我发起的、待我审批的 页面公用 -->
  <div class="aprove-done">
    <div class="wrap g-shadow">
      <div class="header">
        <div class="header">
          <el-tabs class="cus-tabs-border" v-model="activeTopTab" @tab-click="handleTopClick">
            <el-tab-pane v-for="(item, index) in tabTopList" :key="'tab_'+index" :label="item.dictName" :name="item.dictCode"></el-tab-pane>
          </el-tabs>
        </div>

        <!-- <el-form :class="{'formStyle': this.pageType === 'done' || this.pageType === 'mystart' || this.pageType === 'copy'}" ref="form" :model="form" label-width="80px">
          <el-form-item label="标题 :" prop="title">
            <el-input v-model="form.title" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="申请类型 :" prop="approvalType" placeholder="请输入">
            <el-select v-model="form.approvalType" placeholder="请选择">
              <el-option v-for="item in approvalType" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div class="com-head-search-btns ml-30">
          <el-button type="primary" @click="getTableList">查询</el-button>
          <el-button @click="restList">重置</el-button>
        </div> -->
      </div>

      <!-- 列表头部 -->
      <div class="com-list-header" style="padding-left: 0;width: 70%;">
        <el-form class="com-search-box" ref="form" :model="form" label-width="80px">
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="公文标题 :" prop="title">
                <el-input v-model="form.title" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="10">
              <el-form-item label="公文类型 :" prop="approvalType">
                <el-select v-model="form.approvalType" clearable placeholder="请选择">
                  <el-option
                    v-for="item in approvalType"
                    :key="item.dictCode"
                    :label="item.dictName"
                    :value="item.dictCode"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="com-head-search-btns">
          <el-button type="primary" @click="getTableList">查询</el-button>
          <el-button @click="restList">重置</el-button>
        </div>
      </div>

      <!-- <div class="button" v-if="pageType=='copy'"> -->
      <div class="button" v-if="pageType==='list'">
        <el-button class="el-primary-border" round @click="handleAdd('add')">
          <svg-icon icon-class="add" />&nbsp;发起流转
        </el-button>

        <!-- <el-button @click="exportList" :class="{'el-primary-border':chooseRowIds}" :disabled="!chooseRowIds">
          <i class="el-icon-download"></i>&nbsp;批量打印
        </el-button> -->
      </div>

      <!-- 表格 -->
      <el-table v-loading="listLoading" class="cus-table-bg-no" :data="tableData" :row-key="(row)=>{ return row.schemeId }" style="width: 100%" @row-click="rowClick" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- <el-table-column type="index" :index="getIndex" label="序号" width="120"></el-table-column> -->
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">{{ scope.$index+1 }}</template>
        </el-table-column>
        <el-table-column prop="name" label="公文标题" min-width="100%">
          <template slot-scope="scope">
            <!-- <span class="m-dot-box m-danger">
              <i class="m-circle-dot" v-if="scope.row.read==='未读'"></i>
            </span> -->
            {{ scope.row.name }}
            <!-- <span class="m-danger" v-if="scope.row.isCancel">【申请撤销】</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="typeDesc" label="公文类型"></el-table-column>
        <el-table-column prop="code" label="公文编号"></el-table-column>
        <el-table-column prop="org" label="来文单位"></el-table-column>
        <el-table-column prop="docDate" label="来文日期"></el-table-column>
        <!-- <el-table-column prop="endTime" label="完成时间" v-if="pageType!=='pending'"></el-table-column> -->
        <!-- <el-table-column label="是否已读" v-if="pageType==='copy'">
          <template slot-scope="scope">
            <span :class="{'m-tint': scope.row.read==='已读'}">{{ scope.row.read }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="状态" width="150">
          <template slot-scope="scope">
            <!-- 1待处理 2已完成 -->
            <span :class="{
              'm-warning ': scope.row.status==='1',
              'm-tint': scope.row.status==='2'}">
              {{ scope.row.statusDesc }}
            </span>
            <!-- 'm-primary': scope.row.statusCode==='2', -->
            <!-- <span :class="{
                'm-warning ': scope.row.status==='1',
                'm-tint': scope.row.status==='4',
                'm-info': scope.row.status==='6',
                'm-danger': scope.row.status==='3'}">{{ scope.row.status }}</span> -->
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <a class="m-btn mr-10" @click.stop="rowClick(scope.row)">查看</a>
            <!-- <a class="m-btn mr-10" @click.stop="handleAdd('edit', scope.row.id)">编辑</a>
            <a class="m-btn mr-10 m-danger" @click.stop="handleDelete(scope.row.id)">删除</a> -->
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>

    <approve-panel ref="approvePanel" :roleType="pageType" @refresh="initList"></approve-panel>

    <dialog-leave-apply ref="dialogLeaveApply" @refresh="getTableList"></dialog-leave-apply>
  </div>
</template>

<script>
// import bus from '@/utils/bus'
import approvePanel from './dialog/approve-panel' // 审批面板
import dialogLeaveApply from './dialog/leave-apply' // 发起流转
export default {
  components: {
    approvePanel,
    dialogLeaveApply
  },
  // watch: {
  //   $route(path) {
  //     this.activeTopTab = '1'
  //     this.form.approvalType = ''
  //     this.pageType = path.query.state
  //     // this.$refs.approvePanel.closePanel()

  //     if (this.$route.query.actvityId) {
  //       // 从通知跳转过来
  //       this.$nextTick(() => {
  //         this.$refs.approvePanel.init({
  //           actvityId: this.$route.query.actvityId
  //         })
  //       })
  //     } else {
  //       this.$refs.approvePanel.closePanel()
  //     }
  //   }
  // },
  data() {
    return {
      // 页面类型 list:流转列表 pending:我处理的 mystart:我发起的 
      pageType: this.$route.query.state,
      activeTopTab: '0',
      tabTopList: [
        // {
        //   name: '待处理',
        //   value: '1'
        // },
        // {
        //   name: '已完成',
        //   value: '2'
        // },
        // {
        //   name: '全部',
        //   value: '0'
        // },
      ],
      tabList: [],
      tableData: [],
      listLoading: true,
      form: {
        approvalType: '',
        title: ''
      },
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      approvalType: [], // 类型
      chooseRowIds: ''
    }
  },
  created() {
    this.getDict()
    this.initList()

    // 从通知跳转过来
    // if (this.$route.query.actvityId) {
    //   this.$nextTick(() => {
    //     this.$refs.approvePanel.init({ actvityId: this.$route.query.actvityId })
    //   })
    // }
  },
  mounted() {
    // bus.$on('globalApproveEvent', () => {
    //   this.getDataList()
    // })
  },
  methods: {
    handleAdd() {
      // this.$refs.dialogLeaveApply.init('166199946987120471247842155818523')  // 出差审批表
      this.$refs.dialogLeaveApply.init()  // 出差审批表
    },

    getDict() {
      this.$http
        .post(`/collectDict/getSelectDataByArr`, {
          arr: ['document_type', 'document_status']
        })
        .then(res => {
          if (res.success) {
            this.tabTopList = [{dictName: '全部', dictCode: '0'}].concat(res.result.document_status)
            // this.activeTopTab = this.tabTopList[0].dictCode
            this.approvalType = res.result.document_type
            // console.log(222, data)
            // data.forEach(item => {
            //   item.name = item.dictName
            //   item.value = item.dictCode
            // })
            
            // this.renderData.fields.forEach(item => {
            //   if(item.name === 'type') {
            //     item.options = data
            //   }
            // })
            // console.log(this.renderData)
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 初始化表格
    initList(type) {
      // let action = ''
      let apiUrl = ''
      switch (this.pageType) {
        case 'list':
          apiUrl = '/document/bsDocumentInst/list'
          // action = '2'
          break
        case 'pending':
          apiUrl = '/document/bsDocumentInst/listMyProcess'
          // action = '1'
          // this.$store.dispatch('updataSiderbarCount')
          break
        case 'mystart':
          apiUrl = '/document/bsDocumentInst/listMyApply'
          // action = '0'
          break
        // case 'copy':
        //   action = '9'
        //   break
      }
      
      this.listLoading = true
      this.$http
        .get(apiUrl, {
          ...this.listQuery,
          name: this.form.title,
          type: this.form.approvalType,
          status: this.activeTopTab==='0'?'':this.activeTopTab,
          // aaa: this.activeTopTab,

          // action: action,
          // type: this.form.approvalType,
          // title: this.form.title
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            if (
              type === 'dele' &&
              this.listQuery.currentPage > 1 &&
              !res.result.length
            ) {
              this.listQuery.currentPage -= 1
              this.initList()
              return
            }

            this.tableData = res.result.records
            this.total = res.result.total

            // let firstArr = [{ value: null, name: '全部' }]
            // this.approvalType = firstArr.concat(res.result.type)
            // this.tabList = firstArr.concat(res.result.status)
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 表格点击当前行
    rowClick(row) {
      // this.pageType = this.$route.query.state
      this.$refs.approvePanel.init(row)
    },

    // tabs获取点击事件参数
    handleTopClick() {
      this.getTableList()
    },

    // tabs获取点击事件参数
    // handleClick() {
    //   this.getTableList()
    //   this.listQuery.name = this.activeTab
    // },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          title: '您正在删除流转单，是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$http
            .delete('/bsActivity/deleteActivity', {
              id: id
            })
            .then(res => {
              if (res.success) {
                this.$message.success('删除成功')
                this.initList('dele')
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 重置查询
    restList() {
      // this.activeTopTab = '1'

      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 获取表格索引
    getIndex(index) {
      return (this.listQuery.currentPage - 1) * this.listQuery.size + index + 1
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.actvityId)
      })
      this.chooseRowIds = arr.join(',')
    },

    exportList() {
      if (!this.chooseRowIds) {
        this.$message.warning('请选择要打印的数据')
        return
      }
      location.href = '/singleMuseum/workflowInst/printBatch?arr=' + this.chooseRowIds
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    }
  }
}
</script>

<style lang="scss" scoped>
.aprove-done {
  .wrap {
    padding: 30px 20px 30px 30px;
    background: #fff;
    .header {
      display: flex;
      /deep/.el-input {
        width: 300px !important;
      }
    }

    .el-table {
      .m-dot-box.m-danger {
        position: absolute;
        left: 0;
      }
      /deep/ tr {
        cursor: pointer;
      }
      /deep/th.is-leaf {
        border-bottom: 1px solid #eeeff5;
      }
      /deep/td {
        border-bottom: 1px solid #eeeff5;
      }
    }
  }
}
.formStyle {
  margin-left: 76px;
}
</style>


